import { render, staticRenderFns } from "./VendorSwitcher.vue?vue&type=template&id=0cf00658&"
import script from "./VendorSwitcher.vue?vue&type=script&lang=js&"
export * from "./VendorSwitcher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports